import React from 'react';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <div className="page-header">
          <h1>Terms of Service</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>
        
        <div className="terms-content">
          <section>
            <h2>Acceptance of Terms</h2>
            <p>By accessing and using the ProgrammoCeuticals website and services, you accept and agree to be bound by these terms.</p>
          </section>
          
          <section>
            <h2>Use License</h2>
            <p>Permission is granted to access the materials on our website for personal, non-commercial use only.</p>
          </section>
          
          <section>
            <h2>Contact Information</h2>
            <p>If you have any questions about these Terms of Service, please contact us at info@programmoceuticals.com.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;